export default {
  hero_title: "輕鬆實現歐盟 CBAM 碳合規",
  hero_subtitle: "基於歐盟官方/自訂係數的 SME 碳計算平台，快速生成合規報告。",
  what_is_taxecobit: "什麼是 TaxEcoBit？",
  taxecobit_description:
    "TaxEcoBit 是專為受歐盟碳邊境調整機制 (CBAM) 影響的企業設計的合規自動化平台。我們幫助進口商、製造商和中小企業計算產品特定的碳排放，生成符合 CBAM 的文件，並降低監管風險。",
  taxecobit_benefits: "使用 TaxEcoBit，用戶可以：",
  benefit_accurate_calculations: "使用官方和自訂排放係數進行精確的碳計算",
  benefit_cbam_documents: "生成符合 CBAM 的文件以供提交",
  benefit_carbon_cost_tracking: "監控碳成本影響並優化營運效率",
  benefit_api_integration: "通過 API 將合規工作流程與 ERP 和供應鏈系統無縫整合",
  taxecobit_conclusion:
    "通過取代手動電子表格計算和顧問依賴，TaxEcoBit 實現更快、更可靠的合規，降低營運成本。",
  register_now: "立即註冊",
  experience_calculator: "體驗CBAM計算器",
  try_cbam_calculator: "使用CBAM計算器",
  try_cbam_quick_check: "試用 CBAM 快速檢測",
  download_sample_report: "下載範例報告",
  pdf_report: "PDF 報告",
  excel_report: "Excel 報告",
  precise: "精確",
  how_it_works: "運作方式",
  precise_description: "基於歐盟官方/自訂係數，計算誤差 < 5%，符合合規要求。",
  efficient: "高效",
  efficient_description: "支援批次計算，自動生成 PDF/Excel 報告，配置靈活。",
  sme_focused: "專注 SME",
  sme_focused_description: "無需專業背景，直觀介面快速上手。",
  api_support: "API 支援",
  api_support_description: "輕鬆與 ERP/電商系統整合，實現自動化合規報告。",
};
